import React from 'react';
import './App.css';
import Navbar from './Navbar/Navbar';
import Carousel from './Carousel/Carousel';
import Footer from './Footer/Footer';
import Hygiene from './Hygiene/Hygiene';
import Advert from './Advert/Advert';
import Offer from './Offer/Offer';
import Map from './Map/Map';
import {
  HashRouter as Router,
  Route
} from 'react-router-dom';
import OfferPreview from './Offer/Preview/Preview';
import About from './About/About';
import CookieInfo from './CookieInfo/CookieInfo';

function ComponentsList() {
  return (
    <>
      <Carousel></Carousel>
      <Hygiene></Hygiene>
      <Advert></Advert>
      <Offer></Offer>
      <Map></Map>
    </>
  )
}

function App() {
  let cookieInfo;
  let consent = localStorage.getItem('consentGiven');
  
  if (consent !== 'true') {
      cookieInfo = <CookieInfo></CookieInfo>
  }

  return (
    <>
      <Router>
        <Route path="/" component={Navbar} />
        <Route exact path="/" component={ComponentsList} />
        <Route path="/oferta/:id" component={OfferPreview} />
        <Route path="/gabinet" component={About} />
      </Router>
      <Footer></Footer>
      {cookieInfo}
    </>
  );
}

export default App;
